
interface TokenErrorDisplayProps {
  error: string;
  onReset: () => void;
}

export const TokenErrorDisplay = ({ error, onReset }: TokenErrorDisplayProps) => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-4">
      <div className="bg-red-50 border border-red-200 text-red-700 p-4 rounded-md max-w-md">
        <h3 className="font-bold mb-2">Password Reset Link Error</h3>
        <p>{error}</p>
        <p className="mt-4">Please request a new password reset link.</p>
        <button 
          onClick={onReset}
          className="mt-4 bg-red-600 text-white px-4 py-2 rounded hover:bg-red-700"
        >
          Return to Login
        </button>
      </div>
    </div>
  );
};
